export interface Organization {
  id: number;
  name: string;
}

export interface Family {
  id: number;
  name: string;
}

export interface Kid {
  id: number;
  name: string;
  belongsGroupYears: number[];
}

class CombookBinding {
  price: string;
  organization: Organization;
  family: Family;
  kids: Kid[];

  constructor(data: {
    price: string;
    organization: Organization;
    family: Family;
    kids: Kid[];
  }) {
    this.price = data.price;
    this.organization = {
      id: data.organization.id,
      name: data.organization.name
    };
    this.family = {
      id: data.family.id,
      name: data.family.name
    };
    this.kids = (data.kids || []).map(
      (k: Kid): Kid => ({
        id: k.id,
        name: k.name,
        belongsGroupYears: k.belongsGroupYears || []
      })
    );
  }
}

export default CombookBinding;
